/**************************************************
 * Nombre:       Dialogo_Retiro
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {AssuredWorkloadOutlined} from "@mui/icons-material";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Retiro from "../Formularios/Formulario_Retiro";
import {crearRetiro} from "../../CodNegocio/Retiro/crearRetiro";
import {useContext} from "react";
import {usuarioContext} from "../../App";

const Dialogo_Retiro = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Creando Retiro')
        entidad.estado = 'Nuevo'
        entidad.tipo = 'Retiro'


        let dox = await crearRetiro({
            entidad: entidad,
            idBolsillo: entidad.idBolsillo,
            nombreBolsillo: entidad.nombreBolsillo,
            usuario: cData.usuario
        })
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Retiro props={props} editable={!(datos && datos.id)}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    startIcon={<AssuredWorkloadOutlined/>}
                    onClick={() => subirDatos()}
                >Iniciar Retiro</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Retiro